<template>
  <div class="bill_download">
    <v-row>
      <v-col class="text-center">
        <img
          class="ico hover"
          :src="xlsICO"
          alt="xlsx file download"
          @click="generateBill()"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-center hover" @click="generateBill()"
        >Скачать счёт</v-col
      >
    </v-row>
  </div>
</template>
<script>
import xlsICO from "@/assets/xls.svg";
import { getReportUrl } from "@/components/api/localglobal.js";
export default {
  name: "bill_download",
  components: {},
  data: () => ({
    xlsICO,
  }),
  methods: {
    async generateBill() {
      const companyInfo = this.$store.getters.getOrganisationAgent;
      const orderInfo = this.$store.getters.selectedTariff;

      const obj = {
        companyInfo,
        orderInfo,
      };
      const data =
        companyInfo !== undefined &&
        companyInfo !== {} &&
        orderInfo !== undefined &&
        orderInfo !== {} &&
        (await this.$store.dispatch("GENERATE_A_BILL", obj));
      // billNumber
      const savedFile = {
        bill: data.billNumber,
        org_id: companyInfo.id,
        orgShortName: companyInfo.orgShortName,
        inn: companyInfo.inn,
        kpp: companyInfo.kpp,
        jurrAddr: companyInfo.jurrAddr,
        orderInfo,
      };
      await this.$store.dispatch("saveExcellToBack", savedFile);
      await this.fileDownload(`${getReportUrl()}reports/${data.name}`);
    },
  },
};
</script>
<style lang="sass" scoped>
.hover
  cursor: pointer
.ico
  height: 70px
</style>
